module.exports = {
      id: "49bce9b91d4271748ae68a0003bed76bkitchenEquipment-gas-stove.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#49bce9b91d4271748ae68a0003bed76bkitchenEquipment-gas-stove.svg",
      toString: function () {
        return this.url;
      }
    }